/* eslint-disable */
import $ from 'jquery';
import connectFilterNotifications from 'legacy/javascripts/notification.js';
import Cookies from 'js-cookie';
import { Donut } from 'gaugeJS';
import ClipboardJS from 'clipboard';
import Odometer from 'odometer';
import { DateTime, dayOnlyDateFormat } from 'common/utils/date';

window.Odometer = Odometer;

window.GaugeObject = {
  opts: {
    lines: 12,
    angle: 0.13,
    lineWidth: 0.12,
    pointer: {
      length: 0.9,
      strokeWidth: 0.035,
      color: '#000000',
    },
    limitMax: 'false',
    colorStart: '#335168',
    colorStop: '#335168',
    strokeColor: '#DDDDDD',
    generateGradient: true,
  },
  setRewardProgress: function (data) {
    $('div.js-solicitation-stats #reward_progress .gauge').each(function () {
      var val = data[this.id].val;
      var max = data[this.id].max;
      var earned = data[this.id].current_earned;
      this.setAttribute('data-val', val);
      this.setAttribute('data-max', max);
      $(this)
        .parent()
        .find('.progress-count')
        .html(val + ' / ' + max);
      $(this).parent().find('#earned').html(earned);
    });
  },
  setWidgetHtml: function (selector, html) {
    const nonce_pattern = /nonce=".*?"/;
    if (html && html.match(nonce_pattern)) {
      const nonce = document.querySelector('meta[name=csp-nonce]').content;
      html = html.replace(nonce_pattern, `nonce=${nonce}`);
    }
    $('div.js-solicitation-stats ' + selector).html(html);
  },
  setTitle: function (title) {
    $('.js-aggregate-title').text(title);
  },
  canvasFunction: function () {
    $('canvas.gauge').each(function () {
      var data = this.dataset;
      // unfortunately, gaugejs doesn't support reusing the gauge object when there are multiple
      // gauges on the page
      // see: https://github.com/bernii/gauge.js/issues/72
      var gauge = new Donut(this).setOptions(window.GaugeObject.opts);
      gauge.maxValue = data.max;
      if (data.min !== undefined) {
        gauge.setMinValue(parseInt(data.min, 10));
      }
      gauge.set(data.val);
    });

    window.GaugeObject.resizeLittleGauges();
  },
  updateWidgets: function (response) {
    window.GaugeObject.setTitle(response.stream_aggregation_title);
    window.GaugeObject.setRewardProgress(response.reward_progress);
    var $widgets = $('.widgets>.widget');
    if (!$widgets.length) {
      response.widgets.reverse().forEach(function (metric) {
        $('div.js-solicitation-stats').prepend(metric.html);
      });
    } else {
      response.widgets.forEach(function (metric, idx) {
        $($widgets[idx]).replaceWith(metric.html);
      });
    }
    window.GaugeObject.setWidgetHtml('#areas_to_improve', response.areas_to_improve);
    window.GaugeObject.setWidgetHtml('#earned_reward_counts', response.earned_reward_counts);
    window.GaugeObject.setWidgetHtml('#reward_vote_counts', response.reward_vote_counts);
    window.GaugeObject.setWidgetHtml('#areas_of_excellence', response.areas_of_excellence);
    window.GaugeObject.setWidgetHtml('.js-stars-distribution', response.stars_distribution);
    $('#js-rewards-detail-modal').replaceWith(response.rewards_detail_modal);
    window.GaugeObject.canvasFunction();
    var $selects = $('.js-widget-select');

    if (!$selects.length) {
      return;
    }

    $('.js-widget-select select').on('focus', function () {
      $(this).parent().data('previous-name', $(this).find('option:selected').text());
      $(this).parent().data('previous-val', $(this).val());
    });

    $selects.change('input', function () {
      var $form = $(this);
      var previousName = $form.data('previous-name');
      var previousVal = $form.data('previous-val');

      var onConfirm = function () {
        $form.submit();
        window.StreamObject.asyncPageUpdate();
      };

      var onCancel = function () {
        $form.find('select').val(previousVal);
      };

      var newMetric = $form.find('option:selected').text();

      dataConfirmModal.confirm({
        title: 'Are you sure?',
        text:
          'Are you sure you want to change this widget from displaying <b>' +
          previousName +
          '</b> to <b>' +
          newMetric +
          '</b> for all users at your company?',
        onConfirm: onConfirm,
        onCancel: onCancel,
        commitClass: 'btn-default',
        cancelClass: 'btn-danger',
        focus: 'cancel',
      });
    });
  },
  resizeLittleGauges: function () {
    $('canvas.gauge.little').each(function () {
      var left;
      left = ($(this).parent().innerWidth() - $(this).width()) / 2 + 'px';
      $(this).css('margin-left', left);
    });
  },
};

window.StreamObject = {
  titlePrefix: 'You have new feedback! ',
  minInterval: 60 * 1000, // one minute
  defaultInterval: 10 * 60 * 1000, // ten minutes
  login_timestamp: Cookies.get('login_timestamp'),

  loggedOut: function () {
    return Cookies.get('login_timestamp') != this.login_timestamp;
  },

  solicitationFetch: function (
    url,
    aggregate,
    successFunction,
    errorFunction,
    skipInteropCallback
  ) {
    var form = $('section.home .js-filter-form'),
      postPath = form.attr('action'),
      previousRequest = form[0] && form[0].previousRequest;

    if (previousRequest) {
      previousRequest.abort();
      window.ReactInterop.cancelPrevious.publish(formData);
    }

    var allForms = $('.js-filter-form');
    var formData = $.map(allForms, function (filterForm) {
      return $(filterForm).serialize();
    }).join('&');

    // The joined serialized forms above were including both 1 and 0 for checkboxes (has_comments and has_reward)
    // This removes the hidden serialized field in case we want to show comments or rewards
    if (formData.indexOf('has_comments=1') >= 0) formData = formData.replace('&has_comments=0', '');
    if (formData.indexOf('has_reward=1') >= 0) formData = formData.replace('&has_reward=0', '');
    if (formData.indexOf('no_comments=1') >= 0) formData = formData.replace('&no_comments=0', '');
    if (formData.indexOf('no_reward=1') >= 0) formData = formData.replace('&no_reward=0', '');
    if (formData.indexOf('include_completed_qa_reviews=1') >= 0)
      formData = formData.replace('&include_completed_qa_reviews=0', '');
    if (formData.indexOf('include_draft_qa_reviews=1') >= 0)
      formData = formData.replace('&include_draft_qa_reviews=0', '');
    if (formData.indexOf('include_no_qa_reviews=1') >= 0)
      formData = formData.replace('&include_no_qa_reviews=0', '');
    if (formData.indexOf('has_follow_ups=1') >= 0)
      formData = formData.replace('&has_follow_ups=0', '');
    if (formData.indexOf('no_follow_ups=1') >= 0)
      formData = formData.replace('&no_follow_ups=0', '');
    if (formData.search(/solicitation_reporting_timestamp=&+/) >= 0) {
      var defaultTimestamp =
        (window.initializationData &&
          window.initializationData.metricDateFilterConfigs &&
          window.initializationData.metricDateFilterConfigs.solicitation_reporting_timestamp) ||
        'created_at';

      formData = formData.replace(
        /solicitation_reporting_timestamp=&+/,
        'solicitation_reporting_timestamp=' + defaultTimestamp + '&'
      );
    }
    if (formData.search(/team_ids=[^&]+/) >= 0) {
      var teamIds = $('#team_ids').val().split(',');
      var teamIdsString = '';
      teamIds.forEach(function (id, index) {
        if (index) {
          teamIdsString += '&';
        }
        teamIdsString += `team_ids[]=${id}`;
      });

      formData = formData.replace(/team_ids=[^&]+/, teamIdsString);
    }
    if (formData.search(/reporting_group_ids=[^&]+/) >= 0) {
      var groupIds = $('#reporting_group_ids').val().split(',');
      var groupIdsString = '';
      groupIds.forEach(function (id, index) {
        if (index) {
          groupIdsString += '&';
        }
        groupIdsString += `reporting_group_ids[]=${id}`;
      });

      formData = formData.replace(/reporting_group_ids=[^&]+/, groupIdsString);
    }

    window.store &&
      window.store.dispatch({
        type: 'DETERMINED_SERIALIZED_SOLICITATION_STREAM_FILTERS',
        value: { serializedFilters: formData + '&ts=' + new Date().getTime() },
      });

    if (form[0]) {
      form[0].previousRequest = $.ajax({
        type: 'POST',
        url: url || postPath,
        data: formData,
        success: function (response) {
          window.ReactInterop.reviewRecommendationsFetch.publish();
          successFunction(response);
        },
        error: errorFunction,
      });
    }

    // observables register only after initial asyncPageUpdate
    var filterParams = (formData || '').replace(/(\&?authenticity_token\=.+?)(?=\&|$)/, '');

    if (!skipInteropCallback) {
      window.ReactInterop.solicitationsFetch.publish(filterParams);
    }
  },

  asyncPageUpdate: function (url, aggregate, skipInteropCallback) {
    $('.js-stream-loading-indicator .error-message').addClass('hidden');
    $('.js-stream-loading-indicator').removeClass('hidden').removeClass('error');

    if (typeof aggregate === 'undefined') {
      aggregate = true;
    } else if (aggregate === false) {
      url = url + '&aggregate=0';
    }

    window.StreamObject.solicitationFetch(
      url,
      aggregate,
      function (response) {
        var clearFiltersSpan = $('.js-clear-filters');
        $('div.js-paginated-solicitations').html(response.solicitations);
        if (response.any_active_filters) {
          clearFiltersSpan.show();
        } else {
          clearFiltersSpan.hide();
        }
        if (aggregate) {
          window.GaugeObject.updateWidgets(response);
        }
        window.StreamObject.setTooltips();
        window.StreamObject.setClipboard();
        $('.js-stream-loading-indicator').addClass('hidden');
        window.ReactInterop.filterActions.publish();
      },
      function (xhr, textStatus, errorThrown) {
        if (errorThrown !== 'abort') {
          $('.js-stream-loading-indicator').addClass('error');
          $('.js-stream-loading-indicator .error-message').removeClass('hidden');
        }
      },
      skipInteropCallback
    );
  },
  setTooltips: function () {
    $('[data-toggle="tooltip"]').tooltip();
  },
  setClipboard: function () {
    var clipboard = new ClipboardJS('[data-action="clipboard-copy]"');
    clipboard.on('success', function (e) {
      var ogTitle = $(e.trigger).attr('title');
      $(e.trigger).attr('title', 'Copied!').tooltip('fixTitle').tooltip('show');
      window.setTimeout(function () {
        $(e.trigger).tooltip('hide').attr('title', ogTitle).tooltip('fixTitle');
      }, 1000);
    });
  },

  bindFunction: function () {
    /* Metrics */

    function autoSubmitOnChange(id, element) {
      var $formgroup, otherCheckbox;
      if ($(element).prop('checked')) {
        $formgroup = $(element).closest('.yes-no-checkbox');
        otherCheckbox = $formgroup.find(':checkbox:not(#' + id + ')');
        otherCheckbox.prop('checked', false);
      }

      // Submit the form via ajax, and populate the right content areas on success
      window.StreamObject.asyncPageUpdate();
    }

    $('section.home').on('click', '.js-clear-filters a', function (event) {
      event.preventDefault();

      $('.js-filter-form input:checked').not('#include_deactivated').prop('checked', false);
      $('.js-filter-form option').prop('selected', false);
      $('.js-search-input').val('');
      $('.js-filter-form input[name="range_key_label"]').val('');
      $('.js-filter-form input[name="range_key"]').val('');

      window.StreamObject.asyncPageUpdate();
    });

    $('section.home').on('click', 'nav.pagination a', function (event) {
      event.preventDefault();
      var url = $(this)
        .attr('href')
        .replace(/employee_ids=.*?&/, '');
      window.StreamObject.asyncPageUpdate(url, false);
      var topWithPadding = $('.js-paginated-solicitations').offset().top - 30;

      $('html,body').animate(
        {
          scrollTop: topWithPadding + 'px',
        },
        'fast'
      );
    });

    $('section.home').on(
      'change',
      'input#employee_ids, input#team_ids, input#reporting_group_ids, select#employee',
      function () {
        window.StreamObject.asyncPageUpdate($(this).attr('href'));
      }
    );

    $('.js-search-button').click(function () {
      window.StreamObject.asyncPageUpdate($(this).attr('href'));
      return false;
    });

    $('.js-clear-search-button').click(function () {
      $('.js-search-input').val('');
      $('.js-clear-search-group').addClass('hidden');
      window.StreamObject.asyncPageUpdate($(this).attr('href'));
      return false;
    });

    $('.js-search-input').on('keyup', function () {
      if (!$(this).val()) {
        $('.js-clear-search-group').addClass('hidden');
      } else {
        $('.js-clear-search-group').removeClass('hidden');
      }
    });

    $('section.home').on('keypress', '.js-search-input', function (e) {
      var enterKeyCode = 13;
      if (e.which == enterKeyCode) {
        window.StreamObject.asyncPageUpdate($(this).attr('href'));
        return false;
      }
    });

    $('section.home .js-filter-form :checkbox:not(.js-employee-checkbox)').on(
      'change',
      function () {
        var id = $(this).attr('id');
        autoSubmitOnChange(id, this);
      }
    );
    /* End Metrics */
  },
};

// See http://asciicasts.com/episodes/174-pagination-with-ajax
window.AjaxDashboardPages = function () {
  $('.home .pagination a').click(function () {
    window.StreamObject.asyncPageUpdate(this.href, false);
    return false;
  });
};

$(function () {
  $('.container.main').on('click', '.js-comments.collapsible', function () {
    $(this).toggleClass('collapsed');
  });

  $('.js-solicitation-email').on('change', function () {
    $(this).val($.trim($(this).val()));
  });
  if ($('.js-stream-page').length) {
    window.StreamObject.bindFunction();
    window.AjaxDashboardPages();
    if ($('.js-filter-form').data('clientFilter')) {
      connectFilterNotifications.setStreamFilters();
    }

    window.StreamObject.asyncPageUpdate();
  }
});

$(window).resize(function () {
  window.GaugeObject.resizeLittleGauges();
});

$(function () {
  var showDropdown = function () {
    var $formGroup = $(this).closest('.form-group');
    $($formGroup).addClass('active');
    $('.js-list-empty', $formGroup).hide();
    $('.js-list-loading', $formGroup).hide();
    $('.js-list-partial', $formGroup).hide();
  };

  var hideDropdown = function () {
    var $this = $(this);

    setTimeout(function () {
      $this.closest('.form-group').removeClass('active');
    }, 100);
  };

  var handleSearch = function () {
    var searchText = ($(this).val() || '').toLowerCase();
    var $formGroup = $(this).closest('.form-group');
    var $itemList = $('.js-searchable-dropdown-list', $formGroup);
    var $activeItemsList = $('.js-searchable-dropdown-active-list', $formGroup);
    var $noReslts = $('.js-list-empty', $formGroup);
    var $listLoading = $('.js-list-loading', $formGroup);

    if (searchText && 0 < searchText.length && searchText.length < 3) return;

    $itemList.find('li').remove();
    $noReslts.hide();
    $listLoading.show();

    $.getJSON('/api/v1/tags/stream' + '?name=' + searchText, function (data) {
      var hasResults = false;
      $itemList.find('li').remove();
      $listLoading.show();
      $.each(data.tags, function (_index, { name }) {
        $listLoading.hide();
        if ($activeItemsList.find('li[data-value*="' + name.toLowerCase() + '"]').length === 0) {
          appendListElement($itemList, name, 'tags');
          hasResults = true;
        }
      });

      $('.js-searchable-dropdown-list-item').on('click', activateOrDeactivate);
      setupActiveSelections();
      window.StreamObject.bindFunction();

      requestNextPage(data, $formGroup);

      !hasResults ? $noReslts.show() : $noReslts.hide();
    });
  };

  var FILTER_DATA_SOURCE = 'filter_data';

  var escapeHtml = function (text) {
    return $('<div>').text(text).html();
  };

  var streamFilterDateRange = function () {
    var parts = ($('.stream-date-range input[name="range_key"]').val() || '').split(' - ');

    if (parts.length === 2 && parts[0] && parts[1]) {
      return { startDate: parts[0], endDate: parts[1] };
    }

    // Matches the date picker default below, so options describe the feed actually on screen
    return {
      startDate: DateTime.now().minus({ days: 29 }).toFormat(dayOnlyDateFormat),
      endDate: DateTime.now().toFormat(dayOnlyDateFormat),
    };
  };

  var ajaxSearchUrl = function ($formGroup, searchText) {
    if ($formGroup.data('source') !== FILTER_DATA_SOURCE) {
      return '/api/v1/custom_property_values/' + $formGroup.data('id') + '?q=' + searchText;
    }

    var dateRange = streamFilterDateRange();
    var params = $.param({
      type: $formGroup.data('filterType'),
      product_area: $formGroup.data('productArea'),
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    });

    return (
      '/api/v1/filter_data?' +
      params +
      (searchText ? '&label_match=' + encodeURIComponent(searchText) : '')
    );
  };

  // Filter data returns raw label/value pairs, so labels are escaped here. Custom property
  // values arrive as strings already escaped by the server and must not be escaped twice.
  var normalizeDropdownItems = function (data) {
    if (data.values) {
      return $.map(data.values, function (value) {
        return {
          label: escapeHtml(value.label),
          value: String(value.id == null ? value.value : value.id),
        };
      });
    }

    return $.map(data.items || [], function (item) {
      return { label: item, value: item };
    });
  };

  // Brand values are numeric ids, where a substring match would treat "1" as a match for "12"
  var isAlreadySelected = function ($activeItemsList, item, exactMatch) {
    var value = item.value.toLowerCase();
    var selector =
      exactMatch ? 'li[data-value="' + value + '"]' : 'li[data-value*="' + value + '"]';

    return $activeItemsList.find(selector).length !== 0;
  };

  var handleAjaxSearch = function () {
    var searchText = $(this).val().toLowerCase();
    var $formGroup = $(this).closest('.js-ajax-searchable-dropdown');
    var $itemList = $('.js-searchable-dropdown-list', $formGroup);
    var $activeItemsList = $('.js-searchable-dropdown-active-list', $formGroup);
    var $noReslts = $('.js-list-empty', $formGroup);
    var $partialResults = $('.js-list-partial', $formGroup);

    var propertyName = $formGroup.data('name');
    var exactMatch = $formGroup.data('source') === FILTER_DATA_SOURCE;

    $itemList.find('li').show();
    $noReslts.hide();
    $partialResults.hide();

    if (searchText && 0 < searchText.length && searchText.length < 3) return;

    $.get(ajaxSearchUrl($formGroup, searchText), function (data) {
      var hasResults = false;
      $itemList.find('li').remove();
      $.each(normalizeDropdownItems(data), function (_index, item) {
        if (!isAlreadySelected($activeItemsList, item, exactMatch)) {
          appendListElement($itemList, item, propertyName);
          hasResults = true;
        }
      });

      $('.js-searchable-dropdown-list-item').on('click', activateOrDeactivate);
      setupActiveSelections();
      window.StreamObject.bindFunction();

      requestNextPage(data, $formGroup);

      // The repository caps results and has no next page, so ask the user to narrow instead
      data.partial ? $partialResults.show() : $partialResults.hide();

      !hasResults ? $noReslts.show() : $noReslts.hide();
    });
  };

  var handleAjaxDropboxScroll = function () {
    var $formGroup = $(this).closest('.js-ajax-searchable-dropdown');
    var propertyName = $formGroup.data('name');
    var nextPage = $formGroup.data('next');
    var $itemList = $(this);

    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
      if (!nextPage) {
        return;
      }

      $.get(nextPage, function (data) {
        $.each(normalizeDropdownItems(data), function (_index, item) {
          appendListElement($itemList, item, propertyName);
        });

        $('.js-searchable-dropdown-list-item').on('click', activateOrDeactivate);
        setupActiveSelections();
        window.StreamObject.bindFunction();

        requestNextPage(data, $formGroup);
      });
    }
  };

  var requestNextPage = function (data, element) {
    data._links && data._links.next ?
      element.data('next', data._links.next.href)
    : element.data('next', '');
  };

  // `item` is either a plain string or a { label, value } pair when the two differ
  var appendListElement = function (element, item, propertyName) {
    var value = item.value === undefined ? item : item.value;
    var label = item.label === undefined ? item : item.label;
    var elementId = value.toLowerCase().replace(/[\W_]+/g, '-'); // remove non-alphanumerics, create valid element ID
    const valueId = propertyName + '_' + elementId;
    element.append(
      '' +
        '<li class="js-searchable-dropdown-list-item filter-checkbox" data-value="' +
        value.toLowerCase() +
        '">' +
        '<input type="checkbox" name="' +
        propertyName +
        '[]" id="' +
        valueId +
        '" value="' +
        value +
        '" class="checkbox-custom">' +
        '<label for="' +
        valueId +
        '" class="checkbox-custom-label">' +
        label +
        '</label>' +
        '</li>'
    );
  };

  var handleDropdownFocus = function () {
    showDropdown.call(this);
    handleSearch.call(this);
  };

  var handleAjaxDropboxFocus = function () {
    showDropdown.call(this);
    handleAjaxSearch.call(this);
  };

  var setupActiveSelections = function () {
    $('.js-searchable-dropdown-list-item input:checked').each(function () {
      var $formGroup = $(this).closest('.form-group');
      var $listItem = $(this).parent();
      $('.js-searchable-dropdown-active-list', $formGroup).append($listItem);
    });
  };

  var activateOrDeactivate = function () {
    var $clickedElement = $(this);
    var $formGroup = $(this).closest('.form-group');
    if ($('input', $clickedElement).is(':checked')) {
      $('.js-searchable-dropdown-active-list', $formGroup).prepend($clickedElement);
    } else {
      $('.js-searchable-dropdown-list', $formGroup).prepend($clickedElement);
    }
  };

  var deactivateAll = function () {
    $('.js-searchable-dropdown-active-list li').each(function () {
      var $formGroup = $(this).closest('.form-group');
      var $listItem = $(this);
      $('.js-searchable-dropdown-list', $formGroup).append($listItem);
    });
    $('.number-input input').val('');
  };

  function debounce(func, delay, { leading } = {}) {
    let timerId;

    return function (...args) {
      const ctx = this;

      if (!timerId && leading) {
        func.apply(ctx, args);
      }
      clearTimeout(timerId);

      timerId = setTimeout(() => func.apply(ctx, args), delay);
    };
  }

  $('.js-searchable-dropdown-input .search-input')
    .on('focus', handleDropdownFocus)
    .on('blur', hideDropdown)
    .on('keyup', debounce(handleSearch, 500));

  $('.js-ajax-searchable-dropdown-input .search-input')
    .on('focus', handleAjaxDropboxFocus)
    .on('blur', hideDropdown)
    .on('keyup', debounce(handleAjaxSearch, 500));

  $('.js-ajax-searchable-dropdown .js-searchable-dropdown-list').on(
    'scroll',
    debounce(handleAjaxDropboxScroll, 300)
  );

  $('.js-searchable-dropdown-list-item').on('click', activateOrDeactivate);

  $('.js-clear-filters').click(deactivateAll);

  setupActiveSelections();
});

// Bind stream filter datepicker
$(function () {
  if (window.Localize) {
    DateTime.now().setLocale(window.Localize.getLanguage());
  } else {
    DateTime.now().setLocale('en');
  }
  const $datePickerField = $('.stream-date-range input[name="range_key_label"]');
  const $datePickerHiddenField = $('.stream-date-range input[name="range_key"]');
  const $datePickerTimestampHiddenField = $(
    '.stream-date-range input[name="solicitation_reporting_timestamp"]'
  );
  const labelBefore = $datePickerField.val();
  const today = DateTime.now();
  var startDate;
  var endDate;

  if ($datePickerHiddenField.length && $datePickerHiddenField.val().length) {
    const parts = $datePickerHiddenField.val().split(' - ');
    startDate = DateTime.fromISO(parts[0]);
    endDate = DateTime.fromISO(parts[1]);
  } else {
    startDate = DateTime.now().minus({ days: 29 });
    endDate = today;
  }

  $datePickerField
    .daterangepicker({
      startDate: startDate,
      endDate: endDate,
      minDate: DateTime.fromObject({ year: 2015, month: 1, day: 1 }),
      // maxDate: today,
      // maxSpan: { days: 90 },
      ranges: {
        Today: [today, today],
        'Last 30 days': [DateTime.now().minus({ days: 29 }), today],
        'This week': [DateTime.now().startOf('week'), DateTime.now().endOf('week')],
        'This month': [DateTime.now().startOf('month'), DateTime.now().endOf('month')],
      },
    })
    .val(labelBefore);

  $datePickerField.on('apply.daterangepicker', function (_event, picker) {
    const start = picker.startDate.toFormat(dayOnlyDateFormat);
    const end = picker.endDate.toFormat(dayOnlyDateFormat);

    $datePickerHiddenField.val(start + ' - ' + end);
    $datePickerTimestampHiddenField.val(picker.timestamp);

    if (picker.chosenLabel !== 'Custom Range') {
      $datePickerField.val(picker.chosenLabel);
    }

    window.StreamObject.asyncPageUpdate();
  });

  $datePickerField.on('cancel.daterangepicker', function (_event, _picker) {
    $datePickerHiddenField.val('');
    $datePickerField.val('');

    window.StreamObject.asyncPageUpdate();
  });
});
